/**
 * 商品列表接口
 */
export default {
  BASE_URL: '',
  api: [
    {
      name: 'supplierList',
      desc: '供应商列表',
      method: 'GET',
      path: '/sob/supportOrgManage/orgList'
    },
    {
      name: 'editSupplier',
      desc: '新增/编辑供应商',
      method: 'POST',
      path: '/sob/supportOrgManage/addOrg'
    },
    {
      name: 'getSupplierDetail',
      desc: '获取供应商详情',
      method: 'GET',
      path: '/sob/supportOrgManage/orgDetail'
    },
    {
      name: 'getSupplierKindDetail',
      desc: '获取供应商分类详情',
      method: 'GET',
      path: '/sob/supportOrgManage/orgList'
    },
    {
      name: 'exportSupplierBill',
      desc: '导出供应商新增列表',
      method: 'GET',
      path: '/sob/supportOrgManage/exportOrgList'
    },
    {
      name: 'delSupplier',
      desc: '删除供应商',
      method: 'GET',
      path: '/sob/supportOrgManage/delOrg'
    },
    {
      name: 'purOrderList',
      desc: '采购单查询',
      method: 'GET',
      path: '/sob/purchaseBillManage/billList'
    },
    {
      name: 'getPurchaseBill',
      desc: '采购单详情',
      method: 'GET',
      path: '/sob/purchaseBillManage/getPurchaseDetail'
    },
    {
      name: 'exportBillList',
      desc: '导出采购单列表',
      method: 'POST',
      path: '/sob/purchaseBillManage/exportList'
    },
    {
      name: 'serverList',
      desc: '服务单单查询',
      method: 'POST',
      path: '/sob/server/list'
    },
    {
      name: 'checkOrgName',
      desc: '供应商校验重名',
      method: 'GET',
      path: '/sob/supportOrgManage/checkOrgName'
    },
    {
      name: 'checkDelStorage',
      desc: '供应商仓库删除校验',
      method: 'GET',
      path: '/sob/supportOrgManage/checkDelStorage'
    },
    /**
     * 对账管理
     */
    {
      name: 'billStatus',
      desc: '对账管理页签',
      method: 'GET',
      path: '/sob/purchase/collation/billStatus'
    },
    // {
    //   name: 'verifierList',
    //   desc: '运营支撑员',
    //   method: 'GET',
    //   path: '/purchase/collation/verifier'
    // },
    {
      name: 'stateList',
      desc: '对账列表',
      method: 'GET',
      path: '/sob/purchase/collation/list'
    },
    {
      name: 'stateCreate',
      desc: '对账单生成',
      method: 'POST',
      path: '/sob/purchase/collation/create'
    },
    {
      name: 'stateDetail',
      desc: '对账单详情',
      method: 'GET',
      path: '/sob/purchase/collation/detail'
    },
    {
      name: 'handleState',
      desc: '对账单操作',
      method: 'POST',
      path: '/sob/purchase/collation/handleCollation'
    },
    {
      name: 'submitState',
      desc: '对账单提交',
      method: 'POST',
      path: '/sob/purchase/collation/audit'
    },
    {
      name: 'exportState',
      desc: '导出对账详情',
      method: 'POST',
      path: '/sob/purchase/collation/export'
    },
    {
      name: 'exportList',
      desc: '导出对账列表',
      method: 'POST',
      path: '/sob/purchase/collation/exportAll'
    },
    // 以下是list的api
    {
      name: 'purchaseBillManageList',
      desc: '采购单列表',
      method: 'POST',
      path: '/sob/purchaseBillManage/list'
    },
    {
      name: 'orderStatus',
      desc: '采购单订单状态',
      method: 'GET',
      path: '/sob/purchaseBillManage/orderStatus'
    },
    {
      name: 'editDetail',
      desc: '获取快速编辑采购单明细',
      method: 'GET',
      path: '/sob/purchaseBillManage/getEditDetail'
    },
    {
      name: 'editPurchaseDetail',
      desc: '编辑采购单明细',
      method: 'POST',
      path: '/sob/purchaseBillManage/editPurchaseDetail'
    },
    {
      name: 'getById',
      desc: '订单编辑获取详情接口',
      method: 'GET',
      path: '/tm/purchase/getById'
    },
    {
      name: 'save',
      desc: '订单编辑新增接口',
      method: 'POST',
      path: '/ph/purchase/save'
    },
    {
      name: 'save',
      desc: '订单编辑新增接口',
      method: 'POST',
      path: '/ph/purchase/save'
    },
    {
      name: 'orderList',
      desc: 'v5.0.1采购单列表查询',
      method: 'GET',
      path: '/ph/purchase/orderList'
    },
    {
      name: 'getStatusOrderNumV5',
      desc: 'v5.0.1获取状态订单数目',
      method: 'GET',
      path: '/ph/purchase/getStatusOrderNum'
    },
    {
      name: 'getOrderFlowV5',
      desc: 'v5.0.1获取订单流程及操作日志',
      method: 'GET',
      path: '/ph/purchase/getOrderFlow'
    },
    {
      name: 'getOrderV5',
      desc: 'v5.0.1订单编辑获取详情接口',
      method: 'GET',
      path: '/ph/purchase/getOrderById'
    },
    {
      name: 'fetchSupportListV5',
      desc: 'v5.0.1供应商列表',
      method: 'GET',
      path: '/sob/support/list'
    },
    {
      name: 'updateOrderStatusV5',
      desc: 'v5.0.1采购订单状态变更',
      method: 'GET',
      path: '/ph/purchase/updateOrderStatus'
    },
    {
      name: 'checkOrderInfoV5',
      desc: '校验订单关联信息（订单由发货中到已完成阶段）',
      method: 'GET',
      path: '/ph/purchase/checkOrderInfo'
    },
    {
      name: 'receiptListV5',
      desc: '采购收货单列表',
      method: 'GET',
      path: '/tm/purchase/receive/list'
    },
    {
      name: 'receiptDetailV5',
      desc: 'v5.0.1采购收货单详情',
      method: 'GET',
      path: '/tm/purchase/receive/detail'
    },
    {
      name: 'receiveReceiptV5',
      desc: '采购收货单/退货单签收',
      method: 'POST',
      path: '/tm/purchase/receive/receipt'
    },
    {
      name: 'receiveSaveV5',
      desc: '采购收货单/退货单签收',
      method: 'POST',
      path: '/tm/purchase/receive/save'
    },
    {
      name: 'batchReceiptV5',
      desc: '采购收货单/退货单批量签收',
      method: 'POST',
      path: '/tm/purchase/receive/batchReceipt'
    },
    {
      name: 'receiveCancelV5',
      desc: '采购收货单/退货单取消',
      method: 'POST',
      path: '/tm/purchase/receive/cancel'
    },
    {
      name: 'receiveBackV5',
      desc: '采购收货单/退货单回退',
      method: 'POST',
      path: '/tm/purchase/receive/back'
    },
    {
      name: 'getLogV5',
      desc: '采购收货单/退货单日期',
      method: 'GET',
      path: '/tm/purchase/receive/getLog'
    },
    {
      name: 'getBillStatusNumV5',
      desc: '状态页签数量',
      method: 'GET',
      path: '/tm/purchase/receive/getBillStatusNum'
    },
    // v5.0.2
    {
      name: 'getServiceProdListV5',
      desc: '根据销售订单id获取服务单明细列表',
      method: 'GET',
      path: 'ph/purchase/serviceProdList'
    },
    {
      name: 'purchaseQueryExportV5',
      desc: '采购单查询导出',
      method: 'GET',
      path: '/ph/purchase/export'
    },
    // 采购收货单
    {
      name: 'exportDetailExcel',
      desc: '采购单查询导出',
      method: 'POST',
      path: '/tm/purchase/receive/exportDetailExcel'
    },
    {
      name: 'cancelReceiptedV5',
      desc: '已完成送货单-取消',
      method: 'POST',
      path: '/tm/purchase/receipt/cancelReceipted'
    },
    {
      name: 'backListV5',
      desc: '已完成订单-列表',
      method: 'GET',
      path: '/tm/purchase/receipt/backList'
    },
    {
      name: 'saveV5',
      desc: '新增退货单',
      method: 'POST',
      path: '/tm/purchase/receive/thd/save'
    },
    {
      name: 'thdReceiptV5',
      desc: '签收退货单',
      method: 'POST',
      path: '/tm/purchase/receive/thd/receipt'
    },
    {
      name: 'orderCancellationV5',
      desc: '采购一键退整单',
      method: 'POST',
      path: '/tm/purchase/receive/thd/save/shortCut'
    },
    {
      name: 'batchReviewV5',
      desc: '采购批量审核',
      method: 'POST',
      path: '/tm/purchase/receive/thd/receipt/batch'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/purchase/index.js